<template>
  <ul>
    <li v-for="c in categories" :key="c.id">
      <router-link :to="`/shop?web_category=${c.id}`">
        {{ c.name	 }}
        <i v-if="c.children && c.children.length" class="fas fa-angle-down"></i>
      </router-link>
      <ul class="submenu" v-if="c.children && c.children.length">
        <li v-for="child in c.children" :key="child">
          <router-link v-if="child.category='category'" :to="`/shop?web_category=${c.id}&category=${child.id}`">{{ child.name	 }}</router-link>
          <router-link v-else-if="child.category='sub_category'" :to="`/shop?web_category=${c.id}&sub_category=${child.id}`">{{ child.name	 }}</router-link>
          <router-link v-else  :to="`/shop?web_category=${c.id}&brand=${child.id}`">{{ child.name	 }}</router-link>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { formatUrl } from "@/utils/utils";

export default {
  name: "HeaderCategory",
  props: {
    categories: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    formatUrl
  }
};
</script>
